import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase-config";
import Tooltip from "./Tooltip";
import { FaAmazon } from "react-icons/fa";
import authenticatedAxios from "../../redux/actions/AxiosInstance/authenticated";

const UserDetails = ({
  data,
  handleUpdate,
  settings,
  handleUpdateMarketplace,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [inputValue, setInputValue] = useState("Sushil Kumar");
  const [userData, setUserData] = useState([]);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [showConfirmation ,setShowConfirmation] = useState(false)
  const [amazonLoading, setAmazonLoading] = useState(false);
  const [amazonConnected, setAmazonConnected] = useState(false);
  const [checkingAmazonStatus, setCheckingAmazonStatus] = useState(true);

  useEffect(() => {
    setUserData(data);
    setEmail(data.email || "");
  }, [data]);

  useEffect(() => {
    const checkAmazonStatus = async () => {
      try {
        setCheckingAmazonStatus(true);
        const response = await authenticatedAxios.get('/amazon-seller/auth-status');
        
        if (response.data.success) {
          setAmazonConnected(response.data.isConnected);
        }
      } catch (error) {
        console.error('Error checking Amazon status:', error);
        setAmazonConnected(false);
      } finally {
        setCheckingAmazonStatus(false);
      }
    };

    checkAmazonStatus();
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleEmailUpdate = () => {
    const updatedData = { ...userData, email };
    setUserData(updatedData);
    handleUpdate(updatedData);
    setIsEditingEmail(false);
  };

  const resetPassword = async () => {
    await sendPasswordResetEmail(auth, email);
    setShowConfirmation(false);
    toast.success("A password reset request has been sent to your email address!");
  }

  
  const handleAmazonLogin = async () => {
    try {
      setAmazonLoading(true);
      
      const response = await authenticatedAxios.get('/amazon-seller/consent-url');
      
      if (response.data.success && response.data.consentUrl) {
        window.location.href = response.data.consentUrl;
      } else {
        toast.error('Failed to generate Amazon consent URL');
      }
    } catch (error) {
      console.error('Amazon login error:', error);
      toast.error(
        error.response?.data?.message || 
        'Failed to connect to Amazon. Please try again.'
      );
    } finally {
      setAmazonLoading(false);
    }
  };

  return (
    <div
      className="flex flex-col w-full border-primary bg-primary-bg p-4 mt-4 border border-border/100 rounded-2xl"
    >
        {showConfirmation && (
         <div className="fixed inset-0 flex items-center justify-center z-50">
         <div
           className="absolute inset-0 bg-black opacity-50"
           onClick={() => setShowConfirmation(false)}
         ></div>
         <div className="bg-primary-bg border border-primary rounded-lg p-6 z-10 max-w-sm w-[90%] mx-auto">
           <p className="font-Inter text-md font-semibold text-primary">
             Confirm Reset Password
           </p>
           <p className="font-Inter mt-2 text-sm text-gray-100">
             Are you sure you want to reset your password?
           </p>
           <h3 className="text-gray-100 text-lg mb-4"></h3>
           <p className="text-gray-100 mb-6"></p>
           <div className="flex justify-center space-x-4">
             <button
               className="bg-primary-bg text-primary-dark-light cursor-pointer px-4 py-1 rounded border border-border hover:text-secondary-dark transition duration-300"
               style={{}}
               onClick={() => setShowConfirmation(false)}
             >
               Cancel
             </button>
             <button
               className="bg-primary text-primary-dark cursor-pointer px-4 py-1 rounded transition duration-300"
               onClick={resetPassword}
             >
               Confirm
             </button>
           </div>
         </div>
       </div>
      )}
      <div
        className="flex cursor-pointer items-center mb-2"
        onClick={toggleAccordion}
      >
        <div
          className="mr-1 text-primary-dark-light font-bold"
          style={{
            fontSize: "16px",
          }}
        >
          User Details
        </div>
        <div>{/* {isOpen ? <FaAngleUp /> : <FaAngleDown />} */}</div>
      </div>
      {isOpen && (
        <>
          <div className="bg-secondary-dark p-2 rounded-lg mb-3">
            <div className="flex items-center text-white mb-1 font-bold text-sm">
              Username
              <Tooltip text="Username is your unique identifier. It cannot be changed." />
            </div>
            <div className="w-full">
              <input
                type="text"
                value={userData?.name}
                onChange={handleInputChange}
                placeholder="Your Name"
                disabled
                className="text-white border border-primary/40 rounded-xl bg-primary-dark py-2 w-full"
                style={{
                  paddingLeft: "10px",
                  borderRadius: "12px",
                }}
              />
            </div>
          </div>
          <div className="bg-secondary-dark p-2 rounded-lg mb-3">
            <div className="flex text-white mb-1 font-bold text-sm">
              Email
              <Tooltip text="Email is your unique identifier. It cannot be changed." />
            </div>
            <div className="flex items-center capitalize">
              {isEditingEmail ? (
                <>
                  <input
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Your Email"
                    disabled
                    className="text-white border border-primary/40 rounded-xl bg-primary-dark py-2 w-full"
                    style={{
                      paddingLeft: "10px",
                      borderRadius: "12px",
                    }}
                  />
                  {/* <button
                                        className='bg-primary text-primary-dark font-bold rounded-xl px-4 py-1 ml-2'
                                        onClick={handleEmailUpdate}
                                    >
                                        Update
                                    </button> */}
                </>
              ) : (
                <>
                  <input
                    type="email"
                    value={email}
                    readOnly
                    disabled
                    placeholder="Your Email"
                    className="text-white border border-primary/40 rounded-xl bg-primary-dark py-2 w-full"
                    style={{
                      paddingLeft: "10px",
                      borderRadius: "12px",
                    }}
                  />
                  {/* <button
                                        className='bg-primary text-primary-dark font-bold rounded-xl px-4 py-1 ml-2'
                                        onClick={() => setIsEditingEmail(true)}
                                    >
                                        Change
                                    </button> */}
                </>
              )}
            </div>
          </div>
          <div className="bg-secondary-dark p-2 rounded-lg mb-3">
            <div className="flex text-white mb-1 font-bold text-sm">
              Subscription <Tooltip text="This shows your current plan." />
            </div>
            <div className="flex items-center">
              <input
                type="text"
                value={userData?.plan || "--"}
                placeholder="Your Subscription plan"
                className={` text-white border border-primary/40 rounded-xl bg-primary-dark py-2 w-full`}
                style={{
                  paddingLeft: "10px",
                  borderRadius: "12px",
                }}
              />
              <a
                className="bg-primary text-primary-dark font-semibold rounded-md px-4 py-1 ml-2"
                href="https://app.scanprofit.com/payment-options"
                target="_blank"
              >
                Modify/Cancel
              </a>
            </div>
          </div>
          <div className="flex rounded-lg mb-3 gap-2">
            <button
              className="bg-primary text-primary-dark font-bold rounded-md px-4 py-1"
              onClick={() => setShowConfirmation(true)}
            >
              Reset Password
            </button>
            <button
            className="px-3 py-1 rounded-md border-2 border-orange-500 text-orange-500 shadow font-medium hover:border-orange-600 hover:text-orange-600 transition-all duration-150 ease-in-out card w-full sm:w-auto text-center flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleAmazonLogin}
            disabled={amazonLoading || checkingAmazonStatus}
          >
            {amazonLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-500"></div>
                Connecting...
              </>
            ) : checkingAmazonStatus ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-500"></div>
                Checking...
              </>
            ) : (
              <>
                <FaAmazon className="text-lg" />
                {amazonConnected ? "Reconnect to Amazon" : "Connect Amazon Seller Account"}
              </>
            )}
          </button>
          </div>
       
          {/* <div className="bg-secondary-dark p-2 rounded-lg mb-3">
            <div className="flex text-white mb-1 font-bold text-sm">
              Home Marketplace{" "}
              <Tooltip text="Amazon marketplace where you want to buy and sell products." />
            </div>
            <div className="flex items-center">
              <Select
                inputValue={settings?.marketplace}
                handleDropdownChange={(e) => handleUpdateMarketplace(e)}
                dropdownOptions={[
                  "amazon.com",
                  "amazon.de",
                  "amazon.fr",
                  "amazon.ca",
                  "amazon.it",
                ]}
              />
            </div>
          </div> */}
          {/* <div className="bg-secondary-dark p-2 rounded-lg mb-3">
                        <div className='flex text-white mb-1 font-bold text-sm'>
                            Subscription <Tooltip text="Click to Reset your Subscription details." />
                        </div>
                        <div className='flex items-center'>
                            <input type="text" value={"Sushil Kumar"}
                                placeholder="Your Name" className={` text-white border border-primary rounded-xl bg-primary-dark py-2 w-full`}
                                style={{
                                    paddingLeft: '10px',
                                    borderRadius: '12px',
                                }} />
                            <button className='bg-primary text-primary-dark font-bold rounded-xl px-4 py-1 ml-2'>
                                Reset
                            </button>
                        </div>
                    </div> */}
          {/* <div className="bg-secondary-dark p-2 rounded-lg mb-1">
                        <div className='flex text-white mb-1 font-bold text-sm'>
                            Merchant Token <Tooltip text="This is your unique identifier. It cannot be changed." />
                        </div>
                        <input type="text" value={""}
                            className={` text-white border border-primary rounded-xl bg-primary-dark py-2 w-full`}
                            style={{
                                paddingLeft: '10px',
                                borderRadius: '12px',
                            }} />
                    </div> */}
        </>
      )}
    </div>
  );
};

export default UserDetails;
